// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalMessage_root__WFx6V","wrapper":"ModalMessage_wrapper__YT0nB"};